import { FC } from 'react'
import styled from 'styled-components'
import { Product as ProductType } from '../models/contractsModel'

type ProductProps = {
  product: ProductType | null
  onClick: () => void | Promise<void>
}

export const Product: FC<ProductProps> = (props) => {
  const { product, onClick } = props

  if (!product) {
    return (
      <StyledWrap onClick={onClick}>
        <StyledFlex>
          <p>こちらではありません</p>
        </StyledFlex>
      </StyledWrap>
    )
  }

  const { productTitle, productImageUrl, storeName } = product
  const [transactionDate] = product.transactionDate.split('T')

  const MAX_TITLE_LENGTH = 20
  const cutOutProductTitle =
    productTitle.length > MAX_TITLE_LENGTH ? `${product.productTitle.substring(0, MAX_TITLE_LENGTH)}...` : productTitle

  return (
    <StyledWrap onClick={onClick}>
      <StyledFlex>
        <StyledImageWrap>
          <img src={productImageUrl} alt={productTitle} />
        </StyledImageWrap>
        <StyledContentWrap>
          <StyledTitle>{cutOutProductTitle}</StyledTitle>
          <dl>
            <StyledDt>店舗名</StyledDt>
            <StyledDd>{storeName}</StyledDd>
            <StyledDt>購入時期</StyledDt>
            <StyledDd>{transactionDate}</StyledDd>
          </dl>
        </StyledContentWrap>
      </StyledFlex>
    </StyledWrap>
  )
}

const StyledWrap = styled.div`
  border: 1px solid #3e9f26;
  padding: 10px;
  width: 100%;
  border-radius: 10px;
  color: #333;
  width: 300px;
  height: 150px;
  font-size: 14px;
  transition: 0.3s;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
  @media (max-width: 767px) {
    width: 74.5vw;
  }
`
const StyledTitle = styled.p`
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 10px 0;
`

const StyledImageWrap = styled.div`
  width: 40%;
  margin-right: 15px;
  img {
    width: 100%;
  }
`
const StyledContentWrap = styled.div`
  width: 60%;
`
const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
const StyledDt = styled.dt`
  font-size: 12px;
  line-height: 1;
  color: #9c9c9c;
`

const StyledDd = styled.dd`
  margin-bottom: 5px;
`
